"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2 21h19v-3H2zM21 8H2v8h19zM2 3v3h19V3z"
}), 'ViewDaySharp');